import { Progress } from "@/components/ui/progress";

interface LoadingPlaceholderProps {
  className?: string;
  text?: string;
  /**
   * Tailwind width classes to control the progress bar width.
   * Defaults to `w-64`.
   */
  widthClass?: string;
}

export const Loading = ({
  className = "",
  text = "Loading...",
  widthClass = "w-64",
}: LoadingPlaceholderProps) => (
  <div className={`flex flex-col items-center gap-2 ${className}`}>
    {text && <span className="text-sm text-muted-foreground">{text}</span>}
    <div className={`${widthClass} max-w-full`}>
      <Progress
        value={100}
        className="w-full h-2 progress-custom-gradient-fast"
      />
    </div>
  </div>
);
